import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FilesApiService } from '../../../core/services/api/files-api.service';
import { finalize, take } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { ErrorHandlingService } from '../../../core/services/error-handling.service';

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss'],
})
export class DocumentPreviewComponent implements OnInit {
  @Input() doc: any;
  @Input() allowDelete = true;
  @Output() shouldUpdateList = new EventEmitter<number>();

  @ViewChild('deleteMessageComponent', { static: false })
  deleteMessageComponent: any;

  isChangeNameLoading: boolean = false;
  loadingSubmit: boolean = false;
  fileId: any;
  isFileEdit = false;
  tempFileName = '';

  constructor(
    private filesApiService: FilesApiService,
    private notificationService: NotificationsService,
    private errHandle: ErrorHandlingService,
  ) {}

  ngOnInit(): void {}

  openDeleteConfMsg(id: any) {
    this.fileId = id;
    this.deleteMessageComponent.open();
  }

  deleteFile() {
    this.loadingSubmit = true;
    this.filesApiService
      .delete(this.fileId)
      .pipe(finalize(() => (this.loadingSubmit = false)))
      .subscribe(
        (res) => {
          this.deleteMessageComponent.close();
          this.shouldUpdateList.emit(this.fileId);
          this.notificationService.success(res?.message);
        },
        (err) => {
          this.errHandle.errorHandling(err);
        },
      );
  }

  onFileNameClick(name: string): void {
    this.tempFileName = name;
    this.isFileEdit = true;
  }

  discardClicked() {
    this.tempFileName = '';
    this.isFileEdit = false;
  }

  saveClicked() {
    this.isChangeNameLoading = true;
    this.filesApiService
      .updateFileName(this.doc?.id, this.tempFileName)
      .pipe(
        take(1),
        finalize(() => (this.isChangeNameLoading = false)),
      )
      .subscribe(
        (result: any) => {
          this.isFileEdit = false;
          this.doc.name = this.tempFileName;
          this.notificationService.success(
            result?.message || 'The file name is updated successfully.',
          );
        },
        (err) => {
          this.errHandle.errorHandling(err);
        },
      );
  }
}
